import { Trans } from "@lingui/react/macro";
import React from "react";
import { RECOMMEND_RETAILER_URL } from "@Src/constants";

const RecommendRetailerContent = () => {
  return (
    <div className="RecommendRetailer-content" data-testid="recommend-retailer-content">
      <header className="RecommendRetailer-header">
        <h2 className="title t-title-large">
          <Trans>Want to work with us?</Trans>
        </h2>
      </header>

      <div className="RecommendRetailer-body">
        <div className="t-body-med" data-testid="business-owner">
          <Trans>
            Are you a <strong>business owner</strong> interested in joining our program? If so,
            click the link below to submit your application. Our Partnership Marketing team will
            review your details and connect with you as soon as possible.
          </Trans>
        </div>

        <div className="t-body-med" data-testid="member">
          <Trans>
            If you’re a <strong>member</strong> and wish a local business near you offered a deal
            through our program, share the link below with the merchant. The merchant can submit
            their application to us and we’ll take it from there.
          </Trans>
        </div>

        <div>
          <a
            className="cta-submit-application t-title-med"
            href={RECOMMEND_RETAILER_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="submit"
          >
            <Trans>Submit Application Here</Trans>
          </a>
        </div>

        <div className="t-body-small note" data-testid="note">
          <Trans>
            <strong>Note:</strong> Please allow up to 30 days for us to review the merchant
            application. Our Partnership Marketing team will contact you once the application has
            been approved.
          </Trans>
        </div>
      </div>
    </div>
  );
};

export default RecommendRetailerContent;
